import React, { useState } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import SchemaMarkup from './SchemaMarkup'

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => {
    setIsOpen(!isOpen)
  }

  // Function to process string answers with line breaks and bullet points
  const processStringAnswer = (text) => {
    if (!text) return null

    // Split the text by double line breaks to get paragraphs
    const paragraphs = text.split('\n\n')

    return paragraphs.map((paragraph, pIndex) => {
      // Check if this paragraph contains bullet points (lines starting with new lines)
      if (paragraph.includes('\n')) {
        const lines = paragraph.split('\n')

        // First line might be an intro text
        const intro = lines[0].trim()

        // Rest of the lines are potential bullet points
        const bulletPoints = lines.slice(1).filter((line) => line.trim() !== '')

        return (
          <div key={`p-${pIndex}`} className='mb-4'>
            {intro && <p className='mb-2'>{intro}</p>}
            {bulletPoints.length > 0 && (
              <ul className='list-disc pl-5 space-y-1'>
                {bulletPoints.map((point, bIndex) => (
                  <li key={`bullet-${pIndex}-${bIndex}`}>{point.trim()}</li>
                ))}
              </ul>
            )}
          </div>
        )
      }

      // Regular paragraph
      return (
        <p key={`p-${pIndex}`} className='mb-4'>
          {paragraph}
        </p>
      )
    })
  }

  return (
    <div className='mb-4 bg-surface rounded-md overflow-hidden'>
      {/* Question Schema */}
      <SchemaMarkup
        type='Question'
        data={{
          question: question,
          answer:
            typeof answer === 'string'
              ? answer.replace(/\n\n/g, ' ').replace(/\n/g, ' ')
              : `${answer.intro} ${
                  answer.bullets ? answer.bullets.join(' ') : ''
                }`,
        }}
      />
      <div
        className='p-4 font-bold cursor-pointer flex justify-between items-center border-b border-border'
        onClick={toggleOpen}
      >
        <h3 className='text-text-primary'>{question}</h3>
        <FaChevronDown
          className={`text-text-secondary transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </div>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className='p-4 text-text-secondary'>
          {typeof answer === 'string' ? (
            processStringAnswer(answer)
          ) : (
            <>
              <p className='mb-3'>{answer.intro}</p>
              {answer.bullets && (
                <ul className='list-disc pl-5 space-y-2'>
                  {answer.bullets.map((bullet, index) => (
                    <li key={index}>{bullet}</li>
                  ))}
                </ul>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default FaqItem
